import type { RuleNames } from "./feature-names";

/** Spanish names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesEs: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Aprobación del propietario a partir de",
    ID_IMAGE_RETENTION_RULE: "Conservación de las imágenes de identidad",
    FIRST_REPLY_TARGET_RULE: "Plazo de la primera respuesta",
    INTERIM_SUSPENSION_REVIEW_RULE: "Revisión de una suspensión provisional",
    UNANSWERED_JOB_EXPIRY_RULE: "Caducidad de una solicitud sin respuesta",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Periodo de gracia de una suscripción",
    STAFF_SESSION_INACTIVITY_RULE: "Cierre de sesión por inactividad",
  },
  categories: {
    payments: "Pagos",
    support: "Expedientes",
    safety: "Confianza y seguridad",
    onboarding: "Verificación",
    jobs: "Solicitudes",
    access: "Acceso",
  },
};
